export default {
  createNewOpportunity: 'Create a new opportunity',
  ticket: 'Ticket',
  sale: 'Sale',
  chatAlreadyHasOpportunity: 'This person already has an opportunity',
  chatHasManyOpportunities: 'This person has more than one opportunity',
  seeExistentOpportunity: 'See existing',
  NewOpportunity: 'Create New',
  whereCreateNewOpportunity: 'Where do you want to create the opportunity?',
  whereCreateNewTicket: 'Where do you want to create the ticket?',
  howMuchRepresentOpportunity: 'How much represents this opportunity?',
  ticketKeyWord: 'Ticket keyword',
  createOpportunitySuccess: 'Your opportunity was created successfully, you can follow it in ',
  flow: 'Flow',
  step: 'Step',
  updateOpportunitySuccess: 'Your opportunity was updated successfully, you can follow it in ',
  opportunityTitle: 'Opportunity title',
  ticketTitle: 'Ticket title',
  noPipelines: 'No pipelines configured, you can configure one in ',
  ticketNumber: 'Ticket number',
  opportunityNumber: 'Sale number'
}
